/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef, useState } from "react";
import { Global, css } from "@emotion/react";
import LandingSection from "./Landing";
import BrideGroom from "./BrideGroom";
import SaveTheDate from "./SaveTheDate";
import Place from "./Place";
import Give from "./Give";
import RSVP from "./RSVP";
import { styCombineSections } from "./styles";
import OurGallery from "./OurGallery";
import { LocaleProvider } from "../context/LocaleContext";
import LangSelector from "./LangSelector";
import Sound from "./Sound";

const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        @import url("https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&family=Dancing+Script:wght@400;500;600;700&family=Open+Sans:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap");

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
          font-family: "Open Sans", sans-serif;
          background-color: black;
        }

        h1 {
          font-size: 30px;
        }

        h2 {
          font-size: 20px;
        }

        h3 {
          font-size: 18px;
        }

        h4 {
          font-size: 16px;
        }

        h5 {
          font-size: 14px;
        }

        h6 {
          font-size: 12px;
        }

        p {
          font-size: 12px;
          font-weight: 100;
        }

        input,
        select,
        textarea {
          padding: 8px;
          width: 100%;
          background-color: #ffffff;
          border: 1px solid #a99d87;
          border-radius: 4px;
          line-height: 1.4;
          outline: none;
          font-size: 12px;
          height: 36px;
          -webkit-appearance: none;
        }

        select {
          color: black;
        }

        textarea {
          resize: vertical;
          height: 100px;
          font-family: "Open Sans", sans-serif;
          -webkit-appearance: none;
        }

        @media (min-width: 350px) {
          h1 {
            font-size: 32px;
          }
          h2 {
            font-size: 22px;
          }
          h3 {
            font-size: 20px;
          }
          h4 {
            font-size: 18px;
          }
          h5 {
            font-size: 16px;
          }
          h6 {
            font-size: 14px;
          }
          p {
            font-size: 14px;
            font-weight: 100;
          }
        }
      `}
    />
  );
};

const styContainer = css`
  margin: 0 auto;
  max-width: 720px;
`;

const App = () => {
  const section2Ref = useRef<HTMLElement>(null);
  const [isOpened, setIsOpened] = useState(false);

  const scrollToSection2 = () => {
    setIsOpened(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isOpened) {
      setTimeout(() => {
        if (section2Ref.current) {
          section2Ref.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [isOpened]);

  return (
    <LocaleProvider>
      <GlobalStyles />
      <div css={styContainer}>
        <Sound isOpened={isOpened} />
        <LangSelector />
        <LandingSection
          isOpen={isOpened}
          onClickOpenInvitation={scrollToSection2}
        />
        {isOpened && (
          <>
            <section ref={section2Ref}>
              <SaveTheDate />
            </section>
            <BrideGroom />
            <Place />
            <section css={styCombineSections}>
              <RSVP />
              <Give />
            </section>
            <OurGallery />
          </>
        )}
      </div>
    </LocaleProvider>
  );
};

export default App;
